import {DefaultSeoProps} from "next-seo/lib/types";

const defaultSeo: DefaultSeoProps = {
	title: "노랑풍선 [여행을 가볍게]",
	description: "여행을 가볍게! 노랑풍선",
	openGraph: {
		type: "website",
		locale: "ko_KR",
		url: "https://pkg.ybtour.co.kr/",
		siteName: "여행을 가볍게! 노랑풍선",
		images: [
			{
				url: `https://static.ybtour.com/images/YB_metatag.jpg`,
				width: 800,
				height: 600,
				alt: "YB_metatag",
			},
		],
	},
	twitter: {
		handle: "노랑풍선",
		cardType: `https://static.ybtour.com/images/YB_metatag.jpg`,
	},
};

export default defaultSeo;
